export const EXTERNAL_LINKS = {
	APPSTORE_URL: "https://apps.apple.com/fr/app/le-plein-2025/id6745084871",
	PLAYSTORE_URL: "https://play.google.com/store/apps/details?id=com.leplein.app",
};

export const APPLE_APP_ID = "6745084871";
